module.exports = __webpack_public_path__ + "assets/slightly_frowning_face.868bafe24a7e7efc02edbe902ffa5f1c7e05355e9526fb44c72aa3b7b4ea3281.png";